export default __webpack_public_path__ + "static/media/portfolio-1.816771c8.jpg";